import React from 'react'

export default function ModeRail({ style, svgStyle }: any) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgStyle}
    >
      <path
        fill="#212121"
        fillRule="evenodd"
        clipRule="evenodd"
        {...style}
        d="M2.59969 7H13.4036C13.7339 7 14.0033 7.26844 14.0033 7.59764V16.1045C14.0033 16.4337 13.7339 16.7021 13.4036 16.7021H7.99361C7.99881 16.6437 8.00165 16.5849 8.00165 16.5255C8.00165 15.4348 7.11368 14.5499 6.01921 14.5499C4.92474 14.5499 4.03678 15.4348 4.03678 16.5255C4.03678 16.5849 4.03961 16.6437 4.04481 16.7021H2.59969C2.26937 16.7021 2 16.4337 2 16.1045V7.59764C2 7.26844 2.26937 7 2.59969 7Z"
      />
      <path
        fill="#212121"
        fillRule="evenodd"
        clipRule="evenodd"
        {...style}
        d="M21.4003 16.7021H20.364C20.3691 16.6437 20.372 16.5849 20.372 16.5255C20.372 15.4348 19.484 14.5499 18.3896 14.5499C17.2951 14.5499 16.4071 15.4348 16.4071 16.5255C16.4071 16.5849 16.41 16.6437 16.4152 16.7021H15.3788C15.049 16.7021 14.7791 16.4337 14.7791 16.1045V9.3251C14.7791 8.99591 15.0485 8.72746 15.3788 8.72746H17.7502C17.9156 8.72746 18.0578 8.7868 18.1745 8.90266L21.8242 12.5394C21.9409 12.6552 22 12.7979 22 12.9623V16.1045C22 16.4332 21.7297 16.7021 21.4003 16.7021ZM20.4075 12.48L17.6014 9.68397H15.739V12.48H20.4075Z"
      />
      <path
        fill="#212121"
        fillRule="evenodd"
        clipRule="evenodd"
        {...style}
        d="M18.3896 15.0416C19.2119 15.0416 19.8787 15.7061 19.8787 16.5256C19.8787 17.345 19.2119 18.0095 18.3896 18.0095C17.5674 18.0095 16.9006 17.345 16.9006 16.5256C16.9006 15.7061 17.5674 15.0416 18.3896 15.0416ZM18.3895 16.0056C18.6778 16.0056 18.9112 16.2383 18.9112 16.5255C18.9112 16.8128 18.6778 17.0455 18.3895 17.0455C18.1012 17.0455 17.8678 16.8128 17.8678 16.5255C17.8678 16.2383 18.1012 16.0056 18.3895 16.0056Z"
      />
      <path
        fill="#212121"
        fillRule="evenodd"
        clipRule="evenodd"
        {...style}
        d="M6.01916 15.0416C6.84143 15.0416 7.50823 15.7061 7.50823 16.5256C7.50823 17.345 6.84143 18.0095 6.01916 18.0095C5.19689 18.0095 4.53009 17.345 4.53009 16.5256C4.53009 15.7061 5.19689 15.0416 6.01916 15.0416ZM6.01916 16.0056C6.30743 16.0056 6.54088 16.2383 6.54088 16.5255C6.54088 16.8128 6.30743 17.0455 6.01916 17.0455C5.73089 17.0455 5.49744 16.8128 5.49744 16.5255C5.49744 16.2383 5.73089 16.0056 6.01916 16.0056Z"
      />
    </svg>
  )
}
